/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsandpricing2Inputs */

const en_ticketsandpricing2 = /** @type {(inputs: Ticketsandpricing2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tickets & Pricing`)
};

const de_ticketsandpricing2 = /** @type {(inputs: Ticketsandpricing2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tickets & Preise`)
};

/**
* | output |
* | --- |
* | "Tickets & Pricing" |
*
* @param {Ticketsandpricing2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsandpricing2 = /** @type {((inputs?: Ticketsandpricing2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsandpricing2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsandpricing2(inputs)
	return de_ticketsandpricing2(inputs)
});
export { ticketsandpricing2 as "ticketsAndPricing" }